import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/app/[variants]/(staitc-page)/agb/Agb.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/components/RouteMessagesProvider.tsx");
